import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import history from '@history';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';


function UserAvatar(props) {
  let { user, className, sx, disableClick, mode, unread} = props;
  if (!user) return null;
  const isPublic= mode == "public";
  if (user.raw) user= user.raw;
  const userName= user.firstName ? user.firstName : 'Guest';
  const isBot= user.id && user.id.includes("-BOT-");

  
  const navigateToUser= (event) => {
	  if (!disableClick && user.screenName){
		 const pathToUser= (isPublic ? "/public" : "") + "/profile/" + user.screenName;
	  	 history.push({
		    pathname: pathToUser,
		 }); 
		 event.stopPropagation();
     event.preventDefault();
	  } 
  }
  
  return (
	  <div onClick={navigateToUser}>
	    <Badge color="secondary" variant="dot" invisible={!unread}>         
		  <Avatar 
	              sx={sx}
	              className={className}
	              src={user.profileImageUrl}
	              alt={userName.charAt(0)}
	            >
		  	      {isBot && user.id.includes("AI") && <AutoAwesomeIcon color="secondary" />}
		  	      {isBot && user.id.includes("HALESPRING") && 
		  	         <img className="logo-icon w-40 h-40" src="assets/images/logo/HALESPRING-LOGO-100.png" alt="Halespring" />
		  	      }
	              {!isBot && userName.charAt(0)}
	      </Avatar>
	    </Badge> 
      </div>
  );
  
}

 


export default UserAvatar;